<template>
  <div class="w-100">
    <div class="d-flex align-items-center justify-content-center">
      <!-- 主体 -->
      <div class="container-box">
        <!-- 分类+轮播-->
        <div class="d-flex mx-auto pt-2 justify-content-around">
          <!-- 分类卡片 -->
          <cate-menu-list style="z-index: 8"></cate-menu-list>
          <!--  轮播图  -->
          <div class="d-flex flex-fill pl-2" style="max-height: 495px;max-width: 1067px;" >
            <div class="w-100 h-100 position-relative" @mouseenter.stop="bannerOver" @mouseleave.stop="bannerOut">
              <transition name="slide-left-fade">
                <div v-if="bannerBtnshow" class="banner-btn banner-prev-btn d-flex justify-content-center align-items-center" @click.stop="prevSlide('swiper')">
                  <b-img width="14px" src="/imgs/prev.svg"></b-img>
                </div>
              </transition>
              <transition name="slide-right-fade">
                <div v-if="bannerBtnshow" class="banner-btn banner-next-btn d-flex justify-content-center align-items-center" @click.stop="nextSlide('swiper')">
                  <b-img width="14px" src="/imgs/next.svg"></b-img>
                </div>
              </transition>
              <swiper ref="swiper" style="border-radius: 10px"
                      @slidePrevTransitionEnd = "onSlidePrevTransitionEnd"
                      @slideNextTransitionEnd = "onSlideNextTransitionEnd"
                      class="w-100 h-100" :options="bannerOptions" >
                <swiper-slide  v-for="(url,index) in banners" :key="index">
                  <b-img width="1067px" height="495px" :src="getFileAccessHttpUrl(url)"></b-img>
                </swiper-slide>
              </swiper>
              <!--   分页      -->
              <div class="banner-page">
                <span :class="`banner-page-item ${index === bannerIndex?'banner-page-active':''}`" v-for="(item,index) in banners" :key="index"></span>
              </div>
            </div>

          </div>
        </div>

        <!--  Popular Manufacturer  -->
        <div class="d-flex home_brand navbar">
          <div class="d-flex justify-content-between w-100">
            <b-nav-text class="brand-title">Popular Manufacturer</b-nav-text>
            <b-link class="d-flex align-items-center main-text-color">MORE <b-icon font-scale="1.2" icon="chevron-right"></b-icon> </b-link>
          </div>

          <div class="d-flex align-items-center navbar w-100 p-0">
            <swiper :options="swiperOptionVideo">
              <swiper-slide  v-for="(item,index) in popularBrands" :key="index">
                <b-link :href="item.href" >
                  <b-img class="brand-img" :src="item.img"></b-img>
                </b-link>
              </swiper-slide>
            </swiper>
          </div>
        </div>
      </div>
    </div>

    <!--  cate  -->
    <div class="d-flex container-grey-box container-brand-padding justify-content-center ">
      <!-- Categories star -->
      <div class="d-flex  navbar p-0 container-box">
        <div class="d-flex justify-content-between w-100">
          <div class="d-flex">
            <b-nav-text class="brand-title">Categories</b-nav-text>
          </div>
          <b-link to="/category" class="d-flex align-items-center main-text-color">MORE <b-icon font-scale="1.2" icon="chevron-right"></b-icon> </b-link>
        </div>
        <!--   动态横向轮播  -->
        <div class="d-flex align-items-center navbar w-100 p-0">
          <swiper :options="{
          pagination: false,
          autoplay: false,
          loop:false,
          slidesPerView: 4,
          spaceBetween: 10
        }" class="h-100">
            <swiper-slide  v-for="(item,index) in categorieBrands" :key="index">
              <b-link :href="item.href" class="w-100 d-flex flex-column justify-content-center categoire-link">
                <div class="categoire-img-box">
                  <b-img class="w-100 h-100 brand-img" :src="'/imgs'+item.imgUrl"></b-img>
                </div>
                <div class="categoire-title one-line">{{ item.title }}</div>
              </b-link>
            </swiper-slide>
          </swiper>
        </div>
        <!-- Categories End -->
      </div>
    </div>


    <!--  news  -->
    <div class="d-flex  container-brand-padding justify-content-center w-100">
      <!-- news star -->
      <div class="d-flex navbar p-0 container-box">
        <div class="d-flex justify-content-between w-100">
          <div class="d-flex">
            <b-nav-text class="brand-title">News</b-nav-text>
          </div>
          <b-link to="/noticeItem/0" class="d-flex align-items-center main-text-color">MORE <b-icon font-scale="1.2" icon="chevron-right"></b-icon> </b-link>
        </div>

        <!--   动态横向轮播  -->
        <div class="d-flex align-items-center navbar w-100 p-0">
          <swiper :options="{
          pagination: false,
          autoplay: false,
          loop:true,
          slidesPerView: 3,
          spaceBetween: 10
        }">
            <swiper-slide  v-for="(item,index) in newsList" :key="index">
              <div class="news-box">
                <b-link class="news-box-content" :to="'/articleDetail/'+item.id">
                  <div class="news-box-time">{{ item.createTime }}</div>
                  <h2>{{item.title}}</h2>
                  <div class="news-box-content-desc">
<!--                    ICs are used in a wide variety of applications, and they play a key role in every field. In the field of communications, ICs drive cell phones, Internet routers, and communication base stations, enabling seamless communication. Baseband processors, Wi-Fi-->
                    {{item.articleDesc}}
                  </div>
                </b-link>
              </div>
            </swiper-slide>
          </swiper>
        </div>
        <!-- news End -->
      </div>
    </div>

    <!--  Popular Products  -->
    <div class="d-flex container-grey-box container-brand-padding justify-content-center w-100">
      <!-- Popular Products -->
      <div class="d-flex  navbar p-0 container-box">
        <div class="d-flex justify-content-between w-100">
          <div class="d-flex">
            <b-nav-text class="brand-title">Popular Products</b-nav-text>
          </div>
          <b-link class="d-flex align-items-center main-text-color">MORE <b-icon font-scale="1.2" icon="chevron-right"></b-icon> </b-link>
        </div>

        <!--   动态横向轮播  -->
        <div class="d-flex align-items-center navbar w-100 p-0">
          <swiper :options="{
        pagination: false,
        autoplay: true,
        loop:true,
        slidesPerView: 1,
        spaceBetween: 10
        }">
            <swiper-slide v-for="(itemList,index) in productList" :key="index">
              <div class="w-100 product-list-box">
                <b-link :to="'/productDetail/'+item.id" v-for="item in itemList" :key="item.id">{{item.name}}</b-link>
              </div>
            </swiper-slide>
          </swiper>
        </div>
        <!-- Popular Products End -->
      </div>
    </div>

  </div>

</template>

<script>
import categoryMenuList from "@/components/CategoryMenuList.vue";
import {postAction,getAction,getFileAccessHttpUrl} from "@/api/manage";
import {mapGetters} from "vuex";
export default {
  components:{
    "cate-menu-list":categoryMenuList
  },
  data() {
    return {
      slide: 0,
      sliding: null,
      categoryList:[],
      bannerBtnshow:false,
      bannerIndex:0,
      config:{},
      popularBrands:[
        {
          img:'/imgs/brands/nxp.png',
          title:'nxp',
          href:'#'
        },
        {
          img:'/imgs/brands/st.png',
          title:'st',
          href:'#'
        },
        {
          img:'/imgs/brands/infineon.png',
          title:'infineon',
          href:'#'
        },
        {
          img:'/imgs/brands/analog.png',
          title:'analog',
          href:'#'
        },
        {
          img:'/imgs/brands/renesas.png',
          title:'renesas',
          href: '#'
        },
        {
          img:'/imgs/brands/intel.png',
          title:'intel',
          href:'#'
        },
      ],
      categorieBrands:[
        {
          imgUrl:'/categorie/ics.png',
          title:'Integrated Circuits (ICs)'
        },
        {
          imgUrl:'/categorie/motor.png',
          title:'Motors, Actuators, Solenoids and Drivers'
        },
        {
          imgUrl:'/categorie/cap.png',
          title:'Capacitors'
        },
        {
          imgUrl:'/categorie/conn.png',
          title:'Connectors, Interconnects'
        }
      ],
      banners:[],
      bannerOptions:{
        pagination: false,
        autoplay: true,
        loop:true
      },
      newsList:[],
      productList:[],
      swiperOptionVideo: {
        pagination: false,
        autoplay: false,
        loop:false,
        slidesPerView: 6,
        spaceBetween: 10
      },
    }
  },
  computed:{
    ...mapGetters(['getConfig'])
  },
  created() {
    this.init();
  },
  methods: {
    getFileAccessHttpUrl,
    async init() {
      await this.getHomeData();
      await this.getSetiing();
    },
    async getHomeData() {
      await getAction("/front/home", {}).then(res => {
        // this.categoryList = res.result.categoryList
        this.newsList = res.result.articleList;
        this.productList = this.splitArrayIntoChunks(res.result.productList,20);
      })
    },
    getSetiing(){
      this.config = this.getConfig
      this.banners = this.config.bannerList.split(",");
    },
    onSwiper(swiper) {
      // console.log("111", swiper);
    },
    bannerOver(){
      this.bannerBtnshow = true
    },
    bannerOut(){
      this.bannerBtnshow = false
    },
    splitArrayIntoChunks(arr, chunkSize){
      const result = [];
      for (let i = 0; i < arr.length; i += chunkSize) {
        result.push(arr.slice(i, i + chunkSize));
      }
      return result;
    },
    prevSlide(swiper) {
      this.$refs[swiper].swiper.slidePrev();
    },
    nextSlide(swiper) {
      this.$refs[swiper].swiper.slideNext();
    },
    onSlidePrevTransitionEnd(){
      if(this.bannerIndex === 0){
        this.bannerIndex = this.banners.length-1;
      }else{
        this.bannerIndex--
      }
    },
    onSlideNextTransitionEnd(){
      if(this.bannerIndex === this.banners.length-1){
        this.bannerIndex = 0;
      }else{
        this.bannerIndex++
      }
    }
  }
}
</script>

<style lang="scss">
.banner-page{
  position: absolute;
  top: 443px;
  left: 49px;
  z-index: 3;
  .banner-page-item{
    display: inline-block;
    border: 1px solid white;
    height: 12px;
    width: 12px;
    margin-right: 12px;
    border-radius: 12px;
  }
  .banner-page-active{
    background-color: white;
  }
}
.banner-btn{
  position: absolute;
  top: 226px;
  background-color: rgb(0,0,0,.3);
  z-index: 5;
  border-radius: 125px;;
  cursor: pointer;
  width: 40px;
  height: 40px;
}
.banner-prev-btn{
  background-size: cover;
  background-repeat: no-repeat;
  left:15px;
}
.banner-next-btn{
  background-size: cover;
  background-repeat: no-repeat;
  left:1010px;
}

.product-list-box a{
  line-height: 25px;
  font-family: Poppins-Medium;
  font-size: 15px;
  color: black;
  font-weight: 500;
  text-overflow: ellipsis!important;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden!important;
  &:hover{
    color: #0a53be;
  }
}
.product-list-box{
  display: grid;
  grid-template-columns: repeat(4,1fr);
  gap: 15px 30px;
}
.news-box-content .news-box-time{
  font-size: 14px;
  font-family: Poppins-Regular;
  color: #666;
  line-height: 23px;
}
.news-box-content:hover h2{
  text-decoration-line: underline;
  color: #0a53be;
}
.news-box-content h2{
  margin: 12px 0 8px;
  font-size: 20px;
  font-family: Poppins-SemiBold;
  color: var(--main-text-color);
  line-height: 33px;
  text-overflow: ellipsis!important;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden!important;
}
.news-box-content:hover{
  text-decoration-line: none !important;
}
.news-box-content-desc{
  font-size: 14px;
  font-family: Poppins-Medium;
  color: #666;
  line-height: 23px;
  text-overflow: ellipsis!important;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden!important;
}
.news-box-content{
  border-radius: 8px;
  display: inline-block;
  padding: 30px 20px;
  background: #f7f6f9;
}
.news-box{
  /*height: 100%;
  width: 100%;*/
  //background: #5a5a5a;
}
.categoire-link:hover .categoire-title{
  color: #0a53be;
}
.categoire-title{
  font-size: 20px;
  text-align: center;
  background: white;
  color: black;
  font-weight: bold;
  height: 61px;
  line-height: 61px;
}
.categoire-img-box{
  height: 256px;
  width: 325px;
  overflow: hidden;
}
.categoire-img-box img{
  height: auto; /* 保持原始宽高比例 */
  transform: scale(1); /* 初始缩放为1，即正常大小 */
  transition: transform 0.3s; /* 添加平滑过渡效果 */
}

.categoire-img-box:hover img{
  transform: scale(1.2); /* 放大图像到1.2倍大小 */
}

.container-brand-padding{
  padding-top: 80px;
  padding-bottom: 80px;
}
.container-grey-box{
  background-color: #f7f6f9;
}
.swiper-slide{
  border: 0 !important;
}
.brand-img{
  width: 210px;
}
.brand-title{
  font-size: 30px !important;
}
.home_brand{
  width: 100%;
  padding-top: 80px;
  padding-bottom: 80px;
}

.swiper-container {
  width: 100%;
  height: 200px;
  overflow: hidden;
}

.swiper-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
}

.swiper-slide {
  width: 300px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid;
}


.slide-left-fade-enter-active,.slide-right-fade-enter-active{
  transition: all .3s ease;
}
.slide-left-fade-leave-active,.slide-right-fade-leave-active {
  transition: all .3s ease; /* 使用与进入相同的持续时间和缓动函数 */
}
.slide-right-fade-enter, .slide-right-fade-leave-to {
  transform: translateX(10px); /* 进入时从左到右移动10px */
  opacity: 0;
}
.slide-left-fade-enter, .slide-left-fade-leave-to {
  transform: translateX(-10px); /* 进入时从左到右移动10px */
  opacity: 0;
}

</style>